import type { AidPreferenceDto } from "../../types/AidPreferenceDto";
import type { AidPreferenceEntity } from "../../types/AidPreferenceEntity";

export const AidPreferenceEntityToDto = ({ ...rest }: Readonly<AidPreferenceEntity>): AidPreferenceDto => {
    return { ...rest };
};
